
import React from 'react';

interface QuoteProps {
  text: string;
  className?: string;
  /** @deprecated Use size prop instead */
  large?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  align?: 'center' | 'left';
  color?: 'gold' | 'cream' | 'terracotta';
}

const sizeClasses = {
  sm: 'text-lg md:text-xl',
  md: 'text-xl md:text-3xl',
  lg: 'text-3xl md:text-5xl',
  xl: 'text-4xl md:text-6xl',
};

const colorClasses = {
  gold: 'text-[#C9A227]',
  cream: 'text-[#F5F0E6]',
  terracotta: 'text-[#A65D3F]',
};

const Quote: React.FC<QuoteProps> = ({ text, className = "", large = false, size, align = 'center', color = 'gold' }) => {
  const resolvedSize = size ?? (large ? 'lg' : 'md');

  return (
    <div className={`max-w-4xl mx-auto px-6 ${align === 'left' ? 'text-left' : 'text-center'} ${className}`}>
      <p className={`serif italic ${colorClasses[color]} leading-tight font-bold ${sizeClasses[resolvedSize]}`}>
        "{text}"
      </p>
    </div>
  );
};

export default Quote;
